import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020c7517"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps-container m-t-8 bg-fff" }
const _hoisted_2 = { class: "title-panel sign-line-b" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Approval Path", -1))
const _hoisted_4 = { class: "operation-panel" }
const _hoisted_5 = { class: "steps-main" }
const _hoisted_6 = { class: "steps d-f m-t-16" }
const _hoisted_7 = { class: "step-item-content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 512), [
        [_vShow, _ctx.isOpenSteps]
      ])
    ]),
    _withDirectives(_createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "step-item",
                key: index
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["step-item-icon d-f justify-c align-c", [item.approvalStatus === 'Approved' ? 'approve' : (item.approvalStatus === 'Approving' ? 'ongoing-approve' : '')]])
                }, _toDisplayString(item.sequenceIndex), 3),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.roleDtoList, (role, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "step-item-description",
                      key: index
                    }, [
                      _createElementVNode("h2", {
                        class: _normalizeClass([_ctx.getStatusMappingClass(item, role), item.approvalStatus === 'Approved' ? 'approve' : (item.approvalStatus === 'Approving' ? 'ongoing-approve' : '')])
                      }, _toDisplayString(role.roleName), 3),
                      (role.flowUser)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("p", null, _toDisplayString(role.flowUser.approvalTime) + " " + _toDisplayString(role.flowUser.userName), 1),
                            (role.flowUser.comment)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Comments: " + _toDisplayString(role.flowUser.comment), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (role.pendingApproval)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Pending Approve : " + _toDisplayString(role.pendingApproval), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isOpenSteps]
    ]),
    _createElementVNode("div", {
      class: "icon-open bg-fff cursor-p",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOpen && _ctx.toggleOpen(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["font_family icon-xiangxia", {'icon-up': _ctx.isOpenSteps}])
      }, null, 2)
    ])
  ]))
}